import React, { useCallback } from "react";
import { object } from "prop-types";

import { optionsType } from "../../../prop-types";
import { Col, Row } from "reactstrap";
import "./buttonSelectManualSearch.css";
import { LegalEntityIcon, NaturalPersonIcon } from "../../../assets";
import { ENTRY_TYPE } from "../../../features/watch-list-entry/constants/watchListEntryConstants";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const FormikButtonSelectManualSearch = ({
  options,
  field,
  form: { setFieldValue },
  onChange,
}) => {
  const value = getValue(options, field);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base =
      "d-flex justify-content-between selectable-button align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  const RenderIcon = useCallback(({ optionValue }) => {
    if (optionValue === ENTRY_TYPE.NATURAL_PERSON) {
      return <NaturalPersonIcon height={16} width={16} />;
    }

    if (optionValue === ENTRY_TYPE.LEGAL_ENTITY) {
      return <LegalEntityIcon height={16} width={16} />;
    }
  }, []);

  return (
    <Row>
      {options.map((option, i) => {
        return (
          <Col
            key={i}
            lg={6}
            className={i % 2 === 0 ? "pr-2 w3e4r5t6" : "pl-2 w3e4r5t6"}
          >
            <div
              className={getClassName(option)}
              color="primary"
              onClick={() => handleChange(option)}
            >
              <RenderIcon optionValue={option.value} />
              <span>{option.label}</span>
              <div />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

FormikButtonSelectManualSearch.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default FormikButtonSelectManualSearch;



// WEBPACK FOOTER //
// ./src/components/formik/manual-search/ButtonSelectManualSearch.jsx